import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace IncidentTypesFields {
  export enum CommonField {
    IncidentTypesSequentialNumberingFormat = 'IncidentTypes.SequentialNumberingFormat',
  }
}

class CommonConfig extends SettingsSubModule {
  @SettingsSubModule.value(IncidentTypesFields.CommonField.IncidentTypesSequentialNumberingFormat, '')
  sequentialNumberingFormat: SettingValue<string>;
}

export class IncidentTypesModule extends SettingsModule {
  @SettingsModule.value(CommonConfig) common: CommonConfig;
}
